module.exports = __webpack_public_path__ + "static/media/sitemap-open.ea11a3f4.png";